var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.745,
    height: 79.749,
    viewBox: "0 0 79.745 79.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "translate(-1.255 -1.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89825",
    "data-name": "Path 89825",
    d: "M80.521,30.547a13.319,13.319,0,0,0-6.6-8.348,13.319,13.319,0,0,0-3.933-9.943,13.579,13.579,0,0,0-9.943-3.97A13.542,13.542,0,0,0,41.12,3.241,13.5,13.5,0,0,0,22.2,8.323,13.468,13.468,0,0,0,8.323,22.2,13.5,13.5,0,0,0,3.241,41.12,13.5,13.5,0,0,0,8.323,60.042a13.319,13.319,0,0,0,3.933,9.943,13.616,13.616,0,0,0,9.943,3.97A13.542,13.542,0,0,0,41.12,79a13.5,13.5,0,0,0,7.049,2,12.8,12.8,0,0,0,3.525-.482,13.319,13.319,0,0,0,8.348-6.6A13.468,13.468,0,0,0,73.917,60.042,13.5,13.5,0,0,0,79,41.12a13.356,13.356,0,0,0,1.521-10.574Zm-20.146,0L38.56,52.362a2.634,2.634,0,0,1-1.966.816,2.745,2.745,0,0,1-1.966-.816L22.9,40.786a2.783,2.783,0,1,1,3.933-3.933l9.757,9.757L56.443,26.762A2.783,2.783,0,0,1,60.376,30.7Z",
    transform: "translate(0 0)",
    fill: "#0b9100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.50ab1e2babd7bbb5e1c4caa9f5042873.svg";
export { ForwardRef as ReactComponent };